<template>
  <div class="vuetable-filterbar col-md-12">
    <div class="form-group p-l">
      <b-container fluid class="p-a-0">
        <b-row no-gutters class="justify-content-lg-start mb-1">
          <b-col sm="6" md="2" class="p-a-0 m-t-5px mr-1">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                  type="text"
                  class="form-control"
                  v-model="grupo_id"
                  @keyup.enter="doFilter"
              />
              <label class="fl-label" style="left: 13px; right: 12px">N° agrupamento</label>
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px mr-1">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                  type="text"
                  class="form-control"
                  v-model="num_fiscal"
                  @keyup.enter="doFilter"
              />
              <label class="fl-label" style="left: 13px; right: 12px">N° nota fiscal</label>
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px mr-1">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                  type="text"
                  class="form-control"
                  v-model="emissor_cnpj"
                  v-mask="'NN.NNN.NNN/NNNN-NN'"
                  @keyup.enter="doFilter"
              />
              <label class="fl-label" style="left: 13px; right: 12px">Emissor da nota(CNPJ)</label>
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px mr-1">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                  type="text"
                  class="form-control"
                  v-model="codigo_pedido"
                  @keyup.enter="doFilter"
              />
              <label class="fl-label" style="left: 13px; right: 12px">Cód Pedido</label>
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px mr-1">
            <multiselect
                v-model="volumeOccurrenceFilterButton"
                track-by="value"
                label="label"
                id="tipo_ocorrencia"
                placeholder="Ocorrência"
                tag-placeholder="Selecionar"
                select-label="Selecionar"
                selected-label="Selecionado"
                deselect-label="Remover"
                :options="options.volumeOccurrence"
                :hide-selected="false"
            />
          </b-col>
        </b-row>
        <b-row no-gutters class="justify-content-lg-start">
          <b-col sm="6" md="2" class="p-a-0 m-t-5px mr-1">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                  type="text"
                  class="form-control"
                  v-model="usuario_incluido_email"
                  @keyup.enter="doFilter"
              />
              <label class="fl-label" style="left: 13px; right: 12px">Usuario inclusão(Email)</label>
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px mr-1">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                  type="text"
                  class="form-control"
                  v-model="usuario_alterado_email"
                  @keyup.enter="doFilter"
              />
              <label class="fl-label" style="left: 13px; right: 12px">Usuario alteração(Email)</label>
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px mr-1">
            <b-form-datepicker
                locale="pt-br"
                reset-button
                placeholder="Data de inclusão Inicial"
                v-model="data_inclusao"
                class="form-control"
                :date-format-options="{ day: 'numeric', month: 'numeric', year: 'numeric' }"
                @keyup.enter="doFilter"
            />
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
                locale="pt-br"
                reset-button
                placeholder="Data de inclusão Final"
                v-model="data_inclusao_final"
                class="form-control"
                :date-format-options="{ day: 'numeric', month: 'numeric', year: 'numeric' }"
                @keyup.enter="doFilter"
            />
          </b-col>
        </b-row>
        <b-row no-gutters class="justify-content-end">
          <b-col class="d-flex justify-content-end p-a-0 mt-1">
            <div class="input-group-btn">
              <div class="btn-group">
                <button type="button" class="btn btn-secondary btn-outline width-100" @click="doFilter"
                        :disabled="isFilterButtonDisabled">
                  Filtrar
                </button>
                <button type="button" class="btn btn-secondary btn-outline" @click="resetFilter">
                  Limpar
                </button>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import {formatDateSubmit, sanitizeAlphanumeric} from "../utils";

export default {
  components: {Multiselect},
  data() {
    return {
      grupo_id: "",
      num_fiscal: "",
      codigo_pedido: "",
      data_inclusao: "",
      data_inclusao_final: "",
      emissor_cnpj: "",
      tipo_ocorrencia: [],
      usuario_incluido_email: "",
      usuario_alterado_email: "",
      options: {
        units: [],
        volumeOccurrence: [],
      },
      isLoading: {units: false, default: false},
      requestMaker: new Form({params: [], search: "", status: 1}),
    };
  },
  mounted() {
    this.getAllVolumeOccurrence();
  },
  methods: {
    doFilter() {
      if (!this.hasRequiredFilters()) {
        return this.showWarning("Informe ao menos um filtro para realizar a busca.");
      }

      const filterData = {
        grupo_id: this.grupo_id,
        num_fiscal: this.num_fiscal,
        codigo_pedido: this.codigo_pedido,
        data_inclusao: formatDateSubmit(this.data_inclusao),
        emissor_cnpj: sanitizeAlphanumeric(this.emissor_cnpj),
        usuario_incluido_email: this.usuario_incluido_email,
        usuario_alterado_email: this.usuario_alterado_email,
        tipo_ocorrencia: this.tipo_ocorrencia.value,
        data_inclusao_final: formatDateSubmit(this.data_inclusao_final),
      };

      this.$events.fire("filter-set", filterData);
    },
    resetFilter() {
      this.grupo_id = "";
      this.num_fiscal = "";
      this.codigo_pedido = "";
      this.data_inclusao = "";
      this.data_inclusao_final = "";
      this.emissor_cnpj = "";
      this.usuario_incluido_email = "";
      this.usuario_alterado_email = "";
      this.volumeOccurrence = "";
      this.tipo_ocorrencia = [];
      this.$events.fire("filter-reset");
    },
    getAllVolumeOccurrence() {
      this.requestMaker
          .get("/api/inclusaoocorrencia/jsonlist")
          .then((response) => {
            new ReturnApi(response, this, true, false, false);
            this.options.volumeOccurrence = response.param_ocorrencia.map((item) => ({
              label: `${item.cd} - ${item.descr}`,
              value: item.parocorren_id,
            }));
          })
          .catch((error) => new ReturnApi(error, this));
    },
    showWarning(message) {
      this.$Simplert.open({
        title: "Atenção",
        message,
        customCloseBtnText: "Fechar",
        type: "warning",
      });
    },
    hasRequiredFilters() {
      return [
        this.grupo_id,
        this.data_inclusao,
        this.data_inclusao_final
      ].some(value => Array.isArray(value) ? value.length > 0 : !!value);
    },
    fillZerosToLength(value, length) {
      return value.toString().padStart(length, "0");
    },
  },
  computed: {
    volumeOccurrenceFilterButton: {
      get() {
        return this.tipo_ocorrencia || []
      },
      set(value) {
        this.tipo_ocorrencia = value || []
      }
    },
    isFilterButtonDisabled() {
      return !this.hasRequiredFilters();
    },
  },
};
</script>
